import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconForwardLargeComponent } from "./med-icon-forward-large.component";

@NgModule({
  declarations: [
    MedIconForwardLargeComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconForwardLargeComponent,
  ],
})
export class MedIconForwardLargeModule { }
